import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
var FULL_COMPOSE_TOP_DOCKING_HEIGHT = 10;
var INLINE_COMPOSE_TOP_DOCKING_HEIGHT_NO_CARD_VIEW = 6;
var INLINE_COMPOSE_TOP_DOCKING_HEIGHT = 0;
var RIBBON_HEIGHT = 48;
var TOOLBAR_HEIGHT = 49;
var TOOLBAR_HEIGHT_NO_CARD_VIEW = 56;
export function getTopDockingHeight(isInlineCompose) {
    return isInlineCompose
        ? isReadingPaneCardUIEnabled()
            ? INLINE_COMPOSE_TOP_DOCKING_HEIGHT
            : INLINE_COMPOSE_TOP_DOCKING_HEIGHT_NO_CARD_VIEW
        : FULL_COMPOSE_TOP_DOCKING_HEIGHT;
}
export function getBottomDockingHeight(isRibbonShown, isInlineCompose) {
    var isCardUI = isInlineCompose && isReadingPaneCardUIEnabled();
    return ((isCardUI ? TOOLBAR_HEIGHT : TOOLBAR_HEIGHT_NO_CARD_VIEW) +
        (isRibbonShown ? RIBBON_HEIGHT : 0));
}
//# sourceMappingURL=getDockingHeight.js.map